import {Button, Menu} from '@mantine/core';
import React, {useState} from 'react';

import {redirectForDownload} from 'BenchlingUtil';
import notifications from 'notifications';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as TaskRunner from 'util/TaskRunner';

interface DownloadBatchPropertiesCsvButtonProps {
  actionVariant?: 'button' | 'menuItem';
  batchId: string;
}

interface CsvExportResponse {
  url: string;
}

export default function DownloadBatchPropertiesCsvButton({
  actionVariant = 'button',
  batchId,
}: DownloadBatchPropertiesCsvButtonProps): JSX.Element {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadCsv = (): void => {
    setIsDownloading(true);
    TaskRunner.postJSONPromise({
      url: '/1/api/model-hub/prediction-batch:download-properties-csv',
      data: {predictionBatchIds: [batchId]},
    })
      .then((response: CsvExportResponse) => {
        redirectForDownload(response.url);
      })
      .catch((error: {userMessage?: string; responseJSON?: {error?: {userMessage?: string}}}) => {
        notifications.error(
          error.userMessage ?? error.responseJSON?.error?.userMessage ?? 'Failed to download CSV.'
        );
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return actionVariant === 'menuItem' ? (
    <Menu.Item icon={<BenchlingIcon icon="download" />} disabled={isDownloading} onClick={handleDownloadCsv}>
      {isDownloading ? 'Preparing CSV...' : 'Download CSV'}
    </Menu.Item>
  ) : (
    <Button variant="ghost" size="xs" disabled={isDownloading} onClick={handleDownloadCsv}>
      {isDownloading ? 'Preparing CSV...' : 'Download as CSV'}
    </Button>
  );
}
